import {createTheme} from "@mui/material/styles";

const pink = "#FFC0CB";
const lightblue = "#ADD8E6";
const purple = "#800080";
const black = "#000000";

const theme = createTheme({
    palette: {
            background: {
            //default: '#9bedff',

         },

        common: {
            pink: pink,
            lightblue: lightblue,
            purple: purple,
            black: black
        },
        primary: {
            main: black,
            mainGradient: "linear-gradient(to left, purple, pink)",
        },
        secondary: {
            main: lightblue,
            mainGradient: "linear-gradient(to right, lightblue, pink)"
        },
    },
    typography: {
        tab: {
            fontFamily:"'Mate', serif; ",
            textTransform: "none",
            fontSize: "2.5rem",
            color: "#ffffff",
        },
        h1: {
            fontFamily: "'Mate', serif;",
            fontSize: "2.5em"
        },
        h2: {
            fontFamily: "'Mate', serif;",
            fontSize: "2.5em"
        },

        subtitle1: {
            fontFamily: "'Mate', serif;"
        },
        subtitle2: {
            fontFamily: "'Mate', serif;",
            fontSize: "1.5rem"
        },
        buttons: {
            fontFamily: "'Mate', serif;",
            textTransform: "none"
        },
    },
    overrides: {
   MuiCssBaseline: {
     '@global': {
       body: {
         border: '2px solid blue',
         backgroundImage: 'url("https://metaero.org/wp-content/uploads/2022/08/background-1-scaled.jpg")',
       },
     },
   },
 },

});

export default theme
